import { Injectable, inject } from '@angular/core';
import { CurrentUserService, UserType } from '@rma/authentication/public/user';
import { CurrentSubscriptionService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { FeatureFlags, FeaturesService } from '@rma/generic/util/feature-flags';
import { nonNullable } from '@rma/generic/util/operators/non-nullable';
import { cache } from 'decorator-cache-getter';
import { Observable, combineLatest, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { AwardsOverrideService } from './awards-override.service';
import { PromotionType } from './promotion-type.enum';
import { RemaxOverrideService } from './remax-override.service';
@Injectable({
  providedIn: 'root',
})
export class PromotionService {
  private readonly featuresService = inject(FeaturesService);
  private readonly currentSubscriptionService = inject(CurrentSubscriptionService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly remaxAdService = inject(RemaxOverrideService);
  private readonly awardsAdService = inject(AwardsOverrideService);

  @cache
  public get promotionType$(): Observable<PromotionType> {
    const regularBanner$ = this.currentUserService.currentUserContext$.pipe(
      nonNullable(),
      filter((x) => x.userType === UserType.Agent && x.verticalType !== 'Finance'),
      switchMap((_) => this.currentSubscriptionService.currentSubscription$),

      map((x) =>
        x.isFree || (x.onTrial && !x.isSubscribed) ? FeatureFlags.NotSubscribedPromotionType : FeatureFlags.SubscribedPromotionType,
      ),
      switchMap((x) => combineLatest([this.featuresService.getFeature$(x, null), this.remaxAdService.remaxAd$])),
      map(([featureFlag, remax]) => remax ?? featureFlag),
      map((x) => (!x ? 'None' : (x as PromotionType))),
    );
    return this.awardsAdService.awardsAd$.pipe(switchMap((awardAd) => (awardAd ? of(awardAd) : regularBanner$)));
  }
}
